/**
 * 과제 목록에서 줄을 날짜순으로 섞기 위한 값.
 *
 * 목록에는 세 계통이 함께 온다: 우리 과제, 레벨테스트 응시, 레벨테스트 복습.
 * 서로 다른 곳에서 받아 오므로 한 배열로 합치기 어렵다. 그래서 **flex 의 order**
 * 로 줄 세운다. 세 계통이 같은 기준으로 값을 매기면 화면에서 알아서 섞인다.
 *
 * 최근 것이 위로 오도록 날짜가 클수록 작은 값을 준다. 날짜를 모르면 맨 아래로
 * 보낸다(들쭉날쭉하게 끼어드는 것보다 낫다).
 */
export const rowOrderOf = (value) => {
  if (!value) return 1;
  const time = new Date(value).getTime();
  if (Number.isNaN(time)) return 1;
  // 하루 단위로 줄이면 정수 범위 안에 넉넉히 들어간다.
  return -Math.round(time / 86400000);
};
